export const EXPIRED = 'expired';
export const IN_PROGRESS = 'inProgress';
export const NOT_READY = 'notReady';
export const VERIFY_DURATION_MS = 2000;
export const XSOLLA_POPUP_OPEN_DELAY_MS = 2000;

export const MAXIMUM_END_TIME_DAYS = 10;
export const QUANTITY_SHORTED_THRESHOLD = 10_000;

export const OFFER_SOURCE = {
  SHOP: 'shop',
  SEARCH_RESULT: 'search-result',
  RIGHT_SIDEBAR: 'right-sidebar',
  INTERSTITIAL: 'interstitial',
} as const;

export const CATEGORY_IDS = {
  FEATURED: 'featured',
  DAILY: 'daily',
  RUBIES: 'rubies',
  CASH_PACKS: 'cash_packs',
  REWARDS: 'rewards',
  WEBCOINS: 'web_coin',
} as const;

export type CategoryId = (typeof CATEGORY_IDS)[keyof typeof CATEGORY_IDS];
